import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CellPhone, Phone, PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo, DragDropPossibilityChecker, DropAppliedViewModelMessage, FileSelectorViewModel } from "uicomponents";
import { CustomerAttributeValueViewModel, CustomerAttributeViewModel } from "../customerAttribute/customerAttribute-viewModel";
import { EditCustomerViewModel } from "../editCustomer/editCustomer-viewModel";
import { SearchCustomerViewModel } from "../searchCustomer/searchCustomer-viewModel";
import  { CustomerManipulationView } from "./customerManipulation-view"
import { downloadFile, getAsBoolean, getAsNumber } from "src/uicomponents/components/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class CustomerManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت مشتری ها ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.customers = ObservableArray.create<Customer>();
        this.monopolyDistricts = ObservableArray.create<MonopolyDistrict>();
        this.customerAttributes = ObservableArray.create<CustomerAttributeViewModel>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.fileSelector = new FileSelectorViewModel(this);
        this.customerSelector = new SearchCustomerViewModel(this);
        this.customerSelector.onSelectionChanged = q=>{
            let filter = {  
                PaginationInfo : {PageNo: 1, PageSize: 15},
                OrderInfo :  [],
                Filters : {FilterString: `x=>(x.Id!=null && x.Id.Equals(Guid.Parse("${q.id}")))`}
            };
            this.refreshPaged(filter);
        };
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CustomerManipulationView();
    }
    public getTypeId(): string {
        return "VM-A6E93B06-048D-4CFE-A004-1E1B7940E365"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set customers(v: ObservableArray<Customer>) { this._customers = v; } public get customers(): ObservableArray<Customer> { return this._customers;} private _customers: ObservableArray<Customer>;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    public set monopolyDistricts(v: ObservableArray<MonopolyDistrict>) { this._monopolyDistricts = v; } public get monopolyDistricts(): ObservableArray<MonopolyDistrict> { return this._monopolyDistricts;} private _monopolyDistricts: ObservableArray<MonopolyDistrict>;
    public set customerAttributes(v: ObservableArray<CustomerAttributeViewModel>) { this._customerAttributes = v; } public get customerAttributes(): ObservableArray<CustomerAttributeViewModel> { return this._customerAttributes;} private _customerAttributes: ObservableArray<CustomerAttributeViewModel>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loadDistricts();
        this.loadAttributes();
        this.loader.refresh();
    }
    private last : any;
    async realRefresh(filteringInformation:any,runLast:boolean): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            if(runLast){

            }else{
                this.last = JSON.parse(JSON.stringify(filteringInformation));
            }
            let result = await ServerConnection.callServer('/Complex/CustomerServices/ListAllCustomers',{
                FurtherQueryInfo:this.last
            });
            this.customers.update(...result.Customers.map((q,rowNumber)=>{
                let r = new Customer(this);
                r.id = q.Id;
                r.rowNumber = rowNumber+1;
                r.lastName = q.LastName;
                r.name = q.Name;
                r.comment = q.Comment;
                r.customerCode = q.Code;
                r.fullName = q.FullName;
                r.address = q.Address;
                r.provinceName = q.ProvinceName;
                r.provinceId = q.ProvinceId;
                r.cityId = q.CityId;
                r.cityName = q.CityName;
                r.parentId = q.ParentId;
                r.creationTime = moment.utc(q.CreationTime);
                r.isProvider = q.IsProvider;
                r.cellphones.update(...q.CellPhones.map(x=>{
                    let p = new CellPhone(r.phoneInput);
                    p.countryCode = x.CountryCode;
                    p.number = x.Number;
                    return p;
                }));
                r.phones.update(...q.Phones.map(x=>{
                    let p = new Phone(r.phoneInput);
                    p.countryCode = x.CountryCode;
                    p.number = x.Number;
                    p.cityCode = x.CityCode;
                    return p;
                }));
                r.attributeValues.update(...q.Attributes.map(x=>{
                    let relatedAttribute = this.customerAttributes.findIndex(o => o.attributeId == x.AttributeId)[0];
                    let p = new CustomerAttributeValueViewModel(relatedAttribute);
                    p.assignmentId = x.AssignmentId;
                    p.attributeValueId = x.AttributeValueId;
                    p.attributeId = x.AttributeId;
                    p.attributeName = x.AttributeName;
                    p.name = x.Name;
                    p.edited = false;
                    p.appliedFrom = moment.utc(x.AppliedFrom);
                    return p;
                }));
                r.monopolies.update(...q.Monopolies.map(x=>{
                    let p = new MonopolyDistrict(this);
                    p.id = x.DistrictId;
                    p.name = x.Name;
                    p.monopolyHistories.update(...x.MonopolyHistories.map((y,i)=>{
                        let q = new MonopolyHistory(this);
                        q.rowNumber = i + 1;
                        q.districtId = y.DistrictId;
                        q.districtName = y.DistrictName;
                        q.fromTime = moment.utc(y.FromTime);
                        q.untilTime = y.UntilTime == null ? null : moment.utc(y.UntilTime);
                        return q;
                    }));
                    p.monopolyHistories.sort((a,b) => b.fromTime.diff(a.fromTime));
                    return p;
                }));
                
                r.phoneInput.addCellPhone(...r.cellphones);
                r.phoneInput.addPhone(...r.phones);
                r.allAttributes = r.attributeValues.map(p => {return `${p.attributeName}: ${p.name}`}).join(', ');
                r.allMonopolies = r.monopolies.map(p => {return `${p.name}`}).join(', ');
                r.monopolyHistories = r.monopolies.length == 0 ? ObservableArray.create<MonopolyHistory>() : r.monopolies[0].monopolyHistories;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        return this.realRefresh(filteringInformation,false);
    }
    async loadAttributes(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/GetAttributes',{
            });
            this.customerAttributes.update(...result.Attributes.map(q=>{
                let r = new CustomerAttributeViewModel(this);
                r.attributeId = q.Id;
                r.attributeName = q.Name;
                r.attributeValues.update(...q.Values.map(x=>{
                    let p = new CustomerAttributeValueViewModel(r);
                    p.attributeValueId = x.Id;
                    p.attributeId = r.attributeId;
                    p.attributeName = r.attributeName;
                    p.name = x.Name;
                    p.appliedFrom = moment.utc(x.AppliedFrom);
                    return p;
                }));
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    setChildren(dto:any[],parent:MonopolyDistrict): any[]{
        return dto.map(x=>{
            let r = new MonopolyDistrict(this);
            r.id = x.Id;
            r.name = x.Name;
            r.parentId = parent.id;
            r.parentName = parent.name;
            r.childDistricts.update(...this.setChildren(dto.filter(x => x.ParentId == r.id), r));
            return r;
        });
    }
    async loadDistricts(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/AllDistrictsWithChildren',{
            });
            this.monopolyDistricts.update(...result.Districts.filter(q => q.ParentId == null).map(q=>{
                let r = new MonopolyDistrict(this);
                r.id = q.Id;
                r.name = q.Name;
                r.childDistricts.update(...this.setChildren(result.Districts.filter(q => q.ParentId == r.id), r));
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/ImportCustomers',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful){
                await this.messageBoxConfirmSuccess('مشتریان جدید با موفقیت ایجاد شدند.','ورود مشتریان');
                let failedRow :string[]= [];
                result.Result.forEach(q => {
                    if (q.IsFailed == true) {
                        failedRow.push(q.Id);
                    }
                });
                let failed = failedRow.join("\n");
                if(failed != ""){
                    await this.messageBoxConfirmWarning(failed,"سطرهای زیر با خطا روبرو شدند.");
                    return ;
                }
                this.refresh();
            }
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async exportAllCustomers(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/ListAllCustomers',{
                FurtherQueryInfo:null,
                ExcelResult : true
            });
            downloadFile(result.ExcelData,'مشتریان.xlsx');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async setMonopolyToCustomer(dragged: Customer, droppedTo: MonopolyDistrict) {
        try {
            let confirm = await this.messageBoxWarningYesNo('آیا با اختصاص این شعبه به مشتری مطمئنید؟','اختصاص شعبه به مشتری');
            if (confirm == 'no'){
                return;
            }
            this.isLoading = true;
            let monopolyIds = [droppedTo.id];
            let result = await ServerConnection.callServer('/Complex/CustomerServices/ApplyDistrictMonopoly',{
                CustomerId: dragged.id,
                Districts: monopolyIds
            });
            await this.messageBoxConfirmSuccess('شعبه با موفقیت برای مشتری اختصاص یافت.','اختصاص شعبه به مشتری');
            this.realRefresh(null,true);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async setAttributeValueToCustomer(dragged: Customer, droppedTo: CustomerAttributeValueViewModel) {
        try {
            let confirm = await this.messageBoxWarningYesNo('آیا با ثبت این ویژگی برای مشتری مطمئنید؟','ثبت مقدار ویژگی');
            if (confirm == 'no'){
                return;
            }
            this.isLoading = true;
            let attributeValueIds = dragged.attributeValues.map(x => {return x.attributeValueId});
            attributeValueIds.push(droppedTo.attributeValueId);
            let result = await ServerConnection.callServer('/Complex/CustomerServices/UpdateCustomerAttributes',{
                CustomerId: dragged.id,
                NewAttributeValues: attributeValueIds
            });
            this.realRefresh(null,true);
            await this.messageBoxConfirmSuccess('مقدار ویژگی با موفقیت برای مشتری ثبت شد.','ثبت مقدار ویژگی برای مشتری');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    async newAttribute() {
        let r = new CustomerAttributeViewModel(this);
        r.attributeName = '';
        r.edited = true;
        this.customerAttributes.push(r);
    }

    async showEdit(confirmRequested:Customer) {
        let inserter = new EditCustomerViewModel(this);
        inserter.cloneTo(confirmRequested);
        let resultCode = await this.showPopup(inserter);
        if(resultCode=='done'){
            this.realRefresh(null,true);
        }
    }

    async editCheckPointMonopolyTime() {
        let editor = new CheckPointMonopolyTimeViewModel(this);
        let resultCode = await this.showPopup(editor);
        
    }

}

export class Customer extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CustomerManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.phoneInput = new PhoneInputViewModel(this);
        this.phones = ObservableArray.create<Phone>();
        this.cellphones = ObservableArray.create<CellPhone>();
        this.attributeValues = ObservableArray.create<CustomerAttributeValueViewModel>();
        this.monopolies = ObservableArray.create<MonopolyDistrict>();
        this.monopolyHistories = ObservableArray.create<MonopolyHistory>();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set parentId(v: string) { this._parentId = v; } public get parentId(): string { return this._parentId;} private _parentId: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName;} private _lastName: string;
    public set fullName(v: string) { this._fullName = v; } public get fullName(): string { return this._fullName;} private _fullName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set provinceId(v: string) { this._provinceId = v; } public get provinceId(): string { return this._provinceId;} private _provinceId: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName;} private _provinceName: string;
    public set cityId(v: string) { this._cityId = v; } public get cityId(): string { return this._cityId;} private _cityId: string;
    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName;} private _cityName: string;
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    public set phones(v: ObservableArray<Phone>) { this._phones = v; } public get phones(): ObservableArray<Phone> { return this._phones;} private _phones: ObservableArray<Phone>;
    public set cellphones(v: ObservableArray<CellPhone>) { this._cellphones = v; } public get cellphones(): ObservableArray<CellPhone> { return this._cellphones;} private _cellphones: ObservableArray<CellPhone>;
    public set attributeValues(v: ObservableArray<CustomerAttributeValueViewModel>) { this._attributeValues = v; } public get attributeValues(): ObservableArray<CustomerAttributeValueViewModel> { return this._attributeValues;} private _attributeValues: ObservableArray<CustomerAttributeValueViewModel>;
    public set monopolies(v: ObservableArray<MonopolyDistrict>) { this._monopolies = v; } public get monopolies(): ObservableArray<MonopolyDistrict> { return this._monopolies;} private _monopolies: ObservableArray<MonopolyDistrict>;
    public set allAttributes(v: string) { this._allAttributes = v; } public get allAttributes(): string { return this._allAttributes;} private _allAttributes: string;
    public set allMonopolies(v: string) { this._allMonopolies = v; } public get allMonopolies(): string { return this._allMonopolies;} private _allMonopolies: string;
    public set monopolyHistories(v: ObservableArray<MonopolyHistory>) { this._monopolyHistories = v; } public get monopolyHistories(): ObservableArray<MonopolyHistory> { return this._monopolyHistories;} private _monopolyHistories: ObservableArray<MonopolyHistory>;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    public set isProvider(v: boolean) { this._isProvider = getAsBoolean(v); } public get isProvider(): boolean { return this._isProvider;} private _isProvider: boolean;
    
    private _typedParent:CustomerManipulationViewModel;

    async showEdit() {
        this._typedParent.showEdit(this);
    }

    override handleMessage(message:ViewModelMessage){
        if(message instanceof DragDropPossibilityChecker){
            if(message.dragged instanceof MonopolyDistrict && message.droppedTo instanceof Customer){
                return message.createAllowanceResponse(`اختصاص شعبه ${message.dragged.name} به مشتری ${message.droppedTo.name}`);
            }else if(message.dragged instanceof CustomerAttributeValueViewModel && message.droppedTo instanceof Customer){
                return message.createAllowanceResponse(`اضافه کردن مقدار ویژگی ${message.dragged.attributeName} به مشتری ${message.droppedTo.name}`);
            }else{
                return message.createRejectResponse();
            }
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof CustomerAttributeValueViewModel && message.droppedTo instanceof Customer){
            this._typedParent.setAttributeValueToCustomer(message.droppedTo,message.dragged);
            return null;
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof MonopolyDistrict && message.droppedTo instanceof Customer){
            this._typedParent.setMonopolyToCustomer(message.droppedTo,message.dragged);
            return null;
        }else{
            return super.handleMessage(message);
        }
    }
}
export class MonopolyDistrict extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CustomerManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.childDistricts = ObservableArray.create<MonopolyDistrict>();
        this.monopolyHistories = ObservableArray.create<MonopolyHistory>();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set parentId(v: string) { this._parentId = v; } public get parentId(): string { return this._parentId;} private _parentId: string;
    public set parentName(v: string) { this._parentName = v; } public get parentName(): string { return this._parentName;} private _parentName: string;
    public set childDistricts(v: ObservableArray<MonopolyDistrict>) { this._childDistricts = v; } public get childDistricts(): ObservableArray<MonopolyDistrict> { return this._childDistricts;} private _childDistricts: ObservableArray<MonopolyDistrict>;
    public set monopolyHistories(v: ObservableArray<MonopolyHistory>) { this._monopolyHistories = v; } public get monopolyHistories(): ObservableArray<MonopolyHistory> { return this._monopolyHistories;} private _monopolyHistories: ObservableArray<MonopolyHistory>;
    public set selected(v: boolean) { this._selected = v; } public get selected(): boolean { return this._selected;} private _selected: boolean;
    private _typedParent:CustomerManipulationViewModel;
    
    override handleMessage(message:ViewModelMessage){
        if(message instanceof DragDropPossibilityChecker){
            if(message.dragged instanceof Customer && message.droppedTo instanceof MonopolyDistrict){
                return message.createAllowanceResponse(`اختصاص شعبه ${message.droppedTo.name} به مشتری ${message.dragged.name}`);
            }else{
                return message.createRejectResponse();
            }
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof Customer && message.droppedTo instanceof MonopolyDistrict){
            this._typedParent.setMonopolyToCustomer(message.dragged,message.droppedTo);
            return null;
        }else{
            return super.handleMessage(message);
        }
    }
}

export class MonopolyHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set fromTime(v: moment.Moment) { this._fromTime = v; } public get fromTime(): moment.Moment { return this._fromTime;} private _fromTime: moment.Moment;
    public set untilTime(v: moment.Moment) { this._untilTime = v; } public get untilTime(): moment.Moment { return this._untilTime;} private _untilTime: moment.Moment;
    
}

export class CheckPointMonopolyTimeViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: CustomerManipulationViewModel) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.getTime();
    }

    closePopup(resultCode: string = null) {
    }

    GetDefaultView(): View<ViewModel> {
        return null;
    }
    public getTypeId(): string {
        return "set-monopoly-checkpoint"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set day(v: number) { 
        this._day = getAsNumber(v); 
    } public get day(): number { return this._day;} private _day: number;
    
    private _typedParent: CustomerManipulationViewModel;

    async getTime() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CustomerServices/GetCheckPointMonopolyTime',{
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            this.day = result.Day;
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async save() {
        try {
            this.isLoading = true;
            
            let result = await ServerConnection.callServer('/Complex/CustomerServices/SetCheckPointMonopolyTime', {
                Day : this.day

            });
            if (result.IsSuccessful == false) {
                throw "خطا در انجام عملیات";
            }
            await this.messageBoxConfirmSuccess('روزهای رزرو انحصار با موفقیت بروزرسانی شد.', 'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, 'خطا');
        } finally {
            this.isLoading = false;
        }
    }

}
